// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function toString(region) {
  if (region) {
    return "Smart Shift";
  } else {
    return "Porter";
  }
}

function fromString(region) {
  var match = $$String.lowercase_ascii(region);
  switch (match) {
    case "porter" :
        return /* Porter */0;
    case "smart shift" :
        return /* SmartShift */1;
    default:
      return Pervasives.failwith("No Band found for given string");
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var brands = {
  hd: /* Porter */0,
  tl: {
    hd: /* SmartShift */1,
    tl: /* [] */0
  }
};

export {
  brands ,
  toString ,
  fromString ,
  t_decode ,
  
}
/* No side effect */
